export default "__VITE_ASSET__Ctp37HEq__"